import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen pt-20 pb-8 px-4 md:px-6">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <h1 className="text-2xl md:text-4xl font-bold text-white mb-4">Privacy Policy</h1>
          <p className="text-gray-400 text-sm md:text-base">Informativa sulla privacy di Lamoni Lab S.r.l.</p>
        </div>

        <div className="bg-black rounded-xl p-6 md:p-8 space-y-6 text-gray-300">
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">1. Titolare del Trattamento</h2>
            <p className="text-sm md:text-base leading-relaxed">
              Il titolare del trattamento dei dati personali è Lamoni Lab S.r.l., con sede in Via Osteria del Finocchio 37, 00132 Roma, P.IVA 11371351005, 
              email: lamonilab@gmail.com.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">2. Dati Raccolti</h2>
            <p className="text-sm md:text-base leading-relaxed">
              Raccogliamo dati personali forniti volontariamente durante la registrazione e l'utilizzo dei nostri servizi, 
              inclusi nome, email, preferenze di skincare e informazioni sui prodotti utilizzati.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">3. Finalità del Trattamento</h2>
            <p className="text-sm md:text-base leading-relaxed">
              I dati vengono utilizzati per fornire servizi di personalizzazione skincare, gestire l'account utente, 
              comunicazioni commerciali e migliorare i nostri servizi.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">4. Diritti dell'Interessato</h2>
            <p className="text-sm md:text-base leading-relaxed">
              L'utente ha diritto di accesso, rettifica, cancellazione, limitazione del trattamento e portabilità dei dati. 
              Per esercitare tali diritti, contattare lamonilab@gmail.com.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
